import { ReconBankDetailPage } from "@/features/recon-bank/pages/ReconBankDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/recon-bank/$id/detail")({
	validateSearch: (search: Record<string, unknown>) => search,
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["recon_bank.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: ReconBankDetailPage,
});
